import { categories } from '@/mocks/homeData';
import { useNavigate } from 'react-router-dom';

export default function CategoryNav() {
  const navigate = useNavigate();

  const handleClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <section className="relative -mt-10 z-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 px-6 py-6 md:px-8 md:py-7">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg md:text-xl font-bold text-foreground-950 font-heading">影片分类</h2>
            <button
              onClick={() => handleClick('dongzuo')}
              className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap flex items-center gap-1"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </button>
          </div>
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-10 gap-3">
            {categories.map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleClick(cat.slug)}
                className="flex flex-col items-center gap-2 p-3 rounded-xl hover:bg-background-100 transition-all duration-200 group cursor-pointer"
              >
                <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${cat.icon} text-lg md:text-xl`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-foreground-950 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}